// extracted by mini-css-extract-plugin
export default {"errorMessage":"mapa_errorMessage__rUkHC","inputFooter":"mapa_inputFooter__jB7yC"};